// Enumerations
import { MachineStatesEnumeration } from 'enumerations/machine-states.enumeration';
// Types
import { GetStateHandlersUtilsType } from 'containers/get-state/handlers/utils/types/get-state.handlers.utils.type';

const checkoutHasErrorOrIsNotLegit = ({ error, response }: GetStateHandlersUtilsType): boolean =>
  error ||
  [MachineStatesEnumeration.CHECKOUT_COMPLETED, MachineStatesEnumeration.EXPIRED].includes(
    response?.state
  );

const onboardingHasBeenDeclinedByRisk = (
  response: GetStateHandlersUtilsType['response']
): boolean => response?.state === MachineStatesEnumeration.DECLINED;

export { checkoutHasErrorOrIsNotLegit, onboardingHasBeenDeclinedByRisk };
